export const PurchaseModalNavigation = Object.freeze({
    BUNDLE_HIGHLIGHT: "BUNDLE_HIGHLIGHT",
    BUNDLES: "BUNDLES",
    PAYMENT: "PAYMENT",
    REVIEW: "REVIEW",
    CONFIRMATION: "CONFIRMATION",
});
